module.exports = __webpack_public_path__ + "static/media/finish.a10219d2.png";